import $ from 'jquery';

var SELECTOR_POPIN = '.js--popinLogin',
    SELECTOR_POPIN_CLOSE = '.js--popinLoginClose',
    SELECTOR_BTN = '.js-btn-popin';

function displayContainers($popinLogin, $popinLoginModal, $popinBtnClose){
    $popinLogin.show();
    $popinLoginModal.show();
	$popinBtnClose.focus();
}

function hideContainers($popinBtn, $popinLogin, $popinLoginModal){
	$popinBtn.focus();
    $popinLogin.hide();
    $popinLoginModal.hide();
}

function bindEvent($popinBtn, $popinLogin, $popinLoginModal, $popinBtnClose){
	
    $popinBtn.on('click', function(e){
        e.preventDefault();

        if($popinLogin.css('display') === 'none') {
            displayContainers($popinLogin, $popinLoginModal, $popinBtnClose);
        } else  {
            hideContainers($popinBtn, $popinLogin, $popinLoginModal);
        }
    });

    $(SELECTOR_POPIN_CLOSE).on('click', function(e){
        hideContainers($popinBtn, $popinLogin, $popinLoginModal);
    });
	
    $popinLogin.on('click', function(e){
        hideContainers($popinBtn, $popinLogin, $popinLoginModal);
    });
	
	//- Keydown TAB : stoppropagation(), go next focusable item in modal
	$popinLogin.on("keydown", function (e) {
		
		if (e.keyCode === 9 ) {
			e.stopPropagation(); e.preventDefault();
			
            let focusableElements = $popinLogin.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'); //.filter(':visible')
            let currentIndex = focusableElements.index(document.activeElement);
			let newIndex=0;
			if (e.shiftKey)
				newIndex = (currentIndex - 1 + focusableElements.length);
			else
				newIndex = (currentIndex + 1) ;
			newIndex = newIndex % focusableElements.length;
            focusableElements.eq(newIndex).focus();
		}
	});			

	//- Keyup ESC : stoppropagation(), hide()
	$popinLogin.on("keyup", function (e) {
		
		if (e.keyCode === 27) {
			e.stopPropagation(); e.preventDefault();
			hideContainers($popinBtn, $popinLogin, $popinLoginModal);
		}	
			
	});			
}


var initPopinLogin = function () {
    if ($(SELECTOR_POPIN).length && $(SELECTOR_BTN).length) {
        var $popinLogin = $(SELECTOR_POPIN);
        var $popinLoginModal = $popinLogin.children(":first");

        var $popinBtn = $(SELECTOR_BTN);
		var $popinBtnClose = $(SELECTOR_POPIN_CLOSE);
		
        $popinLogin.appendTo(document.body);

        bindEvent($popinBtn, $popinLogin, $popinLoginModal, $popinBtnClose)
    }
}

export {initPopinLogin};


// WEBPACK FOOTER //
// ./src/js/cms/asso/initPopinLogin.js